/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Page_Main_DescInputs */

const en_vc_page_main_desc = /** @type {(inputs: Vc_Page_Main_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft is the free, open-source vector editor from ArtCraft, written in Rust. Download it for Mac, Windows or Linux, or use VectorCraft online in your browser.`)
};

const zh_vc_page_main_desc = /** @type {(inputs: Vc_Page_Main_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 是 ArtCraft 推出的免费开源矢量绘图软件，用 Rust 编写。可下载 Mac、Windows、Linux 版本，也能直接在浏览器中在线使用。`)
};

/**
* | output |
* | --- |
* | "VectorCraft is the free, open-source vector editor from ArtCraft, written in Rust. Download it for Mac, Windows or Linux, or use VectorCraft online in your b..." |
*
* @param {Vc_Page_Main_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_page_main_desc = /** @type {((inputs?: Vc_Page_Main_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Page_Main_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_page_main_desc(inputs)
	return zh_vc_page_main_desc(inputs)
});
export { vc_page_main_desc as "vc.page.main.desc" }